module.exports = __webpack_public_path__ + "213d51e6a782b6d9a8165bb6e9142015.svg";